<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" title="Thay đổi trạng thái xác nhận email?" />
    <div v-if="user">
      <p>
        Chuyển trạng thái xác nhận của email <b>{{ user.email }}</b> ({{ user.name }}) sang
        <b>{{ user.emailConfirmed ? 'Chưa xác nhận' : 'Đã xác nhận' }}</b>
        ?
      </p>
      <p v-if="user.emailConfirmed">
        Lưu ý: Tài khoản sẽ chuyển sang trạng thái bị khóa và không thể đăng nhập vào hệ thống
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Trở về</el-button>
      <CommonButton
        :ref="refs.CONFIRM_BUTTON"
        :type="user && user.emailConfirmed ? 'danger' : 'primary'"
        @click="handleChangeStatus"
      >
        Xác nhận
      </CommonButton>
    </span>
  </el-dialog>
</template>

<script>
import { updateInfo } from '@/services/user_service'
import ModalHeader from '@/components/common/ModalHeader.vue'
import CommonButton from '@/components/common/CommonButton.vue'

export default {
  name: 'ChangeEmailActiveStatusModal',
  components: { CommonButton, ModalHeader },
  data: function () {
    return {
      show: false,
      user: null,
      refs: {
        CONFIRM_BUTTON: 'CONFIRM_BUTTON',
      },
    }
  },
  methods: {
    showModal(user) {
      this.user = user
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    async handleChangeStatus() {
      const editForm = {
        email: this.user.email,
        emailConfirmed: !this.user.emailConfirmed,
      }
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(true)
      let response = await updateInfo(editForm)
      if (response) {
        this.$message.success('Chỉnh sửa thành công')
        this.$emit('success')
        this.closeModal()
      } else {
        this.$message.error('Có lỗi xảy ra')
      }
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(false)
    },
  },
}
</script>

<style scoped></style>
